<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList="searchList" v-on:getSearchObj="getSearchObj" :rightEventList="rightEventList" @rightFunc="rightFunc" />
    </div>
    <el-main class="listTabel">
      <!-- <BaseTable :data="tableData" :optimize='true'
          tooltip-effect="dark"
          :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="searchParams.current"
          :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable> -->

      <el-table
        ref="multipleTable"
        :data="tableData"
        align="center"
        :cell-class-name="cellClassName"
        :header-cell-style="{
          textAlign: 'center',
          color: '#333333',
          fontSize: '14px',
          fontWeight: 'bold',
          backgroundColor: '#FAFAFA',
        }"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column label="序号" type="index" align="center" fixed="left"></el-table-column>
        <el-table-column label="协同目的" prop="title" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="协同类型" prop="type" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.type == "message" ? "图文协同" : "视频协同" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会诊时间" prop="startTime" width="167" align="center"></el-table-column>
        <el-table-column label="发起医生" prop="fromDoctorName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="发起医生所属团队" prop="fromDoctorTeamName" align="center" show-overflow-tooltip width="140"></el-table-column>
        <el-table-column label="参与医生" prop="admissionDoctorName" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.admissionDoctorName ? scope.row.admissionDoctorName : scope.row.admissionDoctorTeamName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="问诊患者" prop="patientName" align="center"></el-table-column>
        <el-table-column label="医生需求" prop="fromDoctorReq" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="会诊价格" prop="amountPayable" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amountPayable }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="当前状态" prop="status" align="center">
          <template slot-scope="scope">
            <span class="status-style">{{ synergyStatusObj[scope.row.status] }}</span>
          </template>
        </el-table-column>

        <el-table-column label="创建人" prop="createUserName" align="center"></el-table-column>
        <el-table-column label="创建来源" prop="sponsorType" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sponsorType == 'casemgr' ? '后台':'医生端' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="167" prop="createTime" align="center"></el-table-column>

        <el-table-column align="center" min-width="200" fixed="right" label="操作">
          <template slot-scope="scope">
            <!-- 可改价 -->
            <el-button v-if="scope.row.status == 'waiting' || scope.row.status == 'ready' || scope.row.status == 'unpay'" @click="onEditClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button v-if="scope.row.status == 'underway' || scope.row.status == 'ended' || scope.row.status == 'rejected' || scope.row.status == 'canceled'"
              @click="onLookClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="goToRoom(scope.row)" type="text" size="small"
              v-if="scope.row.status == 'waiting' || scope.row.status == 'ready' || scope.row.status == 'underway'
              || scope.row.status == 'ended' || scope.row.status == 'rejected' || (scope.row.status == 'canceled' && scope.row.chatRoomGroupCode)">进入房间</el-button>
            <el-button v-if="scope.row.status == 'ended' && !scope.row.synergyConclusion" @click="handleWriteSummary(scope.row)" type="text" size="small">填写小结</el-button>
            <el-button v-if="scope.row.status == 'ended' && scope.row.synergyConclusion" @click="handleLookSummary(scope.row)" type="text" size="small">查看小结</el-button>
            <!-- v-if="scope.row.status == 'ended'"  -->
            <el-button v-if="scope.row.status == 'ended' && scope.row.type == 'video'" @click="handleLookVideo(scope.row)" type="text" size="small">查看录屏</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="searchParams.current" :page-sizes="[10, 20, 30, 50]" :page-size="searchParams.size" 
        layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-main>
    <!-- 填写小结 -->
    <WriteSummaryDialog v-if="showSummary" :showSummary.sync="showSummary" :selectRecordRow="selectRecordRow"></WriteSummaryDialog>

    <div v-if="lookVideo" class="ocr-text-wrapper">
      <div class="folder-wrapper">
        <div @mousedown="moveSelect" style="flex:1;padding:5px 0">
          <i class="el-icon-rank" style="font-size:24px"></i>
        </div>
        <div style="width:26px">
          <i class="el-icon-close" style="font-size:24px" @click="lookVideo = false"></i>
        </div>
      </div>
      <div class="viedo" style="width:450px">
        <!-- 播放m3u8视频 -->
        <video-player ref="videoPlayer" class="vjs-custom-skin" :options="playerOptions" @ended="onPlayerEnded($event)">
        </video-player>
      </div>
      <div class="change-video-btns">
        <!-- {{playerOptions.sourcesList.length}}
        {{currentVideoIndex}} -->
        <!-- <span>
          <img src="@/assets/images/pre-video.png" />
          <span>上一段</span>
        </span>
        <span>
          <img src="@/assets/images/next-video.png" />
          <span>下一段</span>
        </span> -->
        <el-button size="medium" :disabled="currentVideoIndex == 0" @click="preVideo()">
          <img src="@/assets/images/pre-video.png" />
          上一段
        </el-button>
        <el-button size="medium" :disabled="currentVideoIndex == playerOptions.sourcesList.length - 1" @click="nextVideo()">
          <img src="@/assets/images/next-video.png" />
          下一段
        </el-button>
      </div>
    </div>
  </el-container>
</template>

<script>
import { pageSynergyRecord, rtcAudioRecord, synergyStatus } from "@/api/consultationCooperate";
import WriteSummaryDialog from "./component/WriteSummaryDialog.vue";
// import ShowVideo from "@/views/SystemSettings/component/video.vue";
// import videojs from 'video.js'

// import "videojs-contrib-hls"


export default {
  components: {
    WriteSummaryDialog,
    // ShowVideo
  },
  props: {},
  data() {
    return {
      playerOptions: {
        height: '360',
        playbackRates: [0.7, 1, 1.3, 1.5, 1.7],
        //需要循环的列表
        sourcesList: [],
        sources: [
          // {
          //   // type: "video/mp4",
          //   src: 'http://jiayi-agora.oss-cn-hangzhou.aliyuncs.com/agora/recording/1691688491486515201/04e9dbabd44798df66c1d1a88ffe0892_c69d22d0-238b-4d41-b1cd-ba8817f2d36d.m3u8'
          // }
        ],
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 时长显示
          remainingTimeDisplay: false, // 剩下时间
          currentTimeDisplay: false, // 当前时间
          volumeControl: true, // 声音控制键
          playToggle: true, // 暂停和播放键
          progressControl: true, // 进度条
          fullscreenToggle: true // 全屏按钮
        },
        loop: false, //循环列表，这里的loop必须是false
        muted: false,// 是否在不全屏状态下外放声音
        autoplay: true,// 是否浏览器 准备好后自动播放
        isLive: false,// 是否直播
        flash: { hls: { withCredentials: false } },
        poster: "",
        currentSourceSrc: ''
      },

      // videoIndex: 0,
      // player: null,

      selectRecordRow: {},
      showSummary: false,
      breadList: [{ name: "协同管理" }, { name: "协同记录" }],
      rightEventList: [{ eventName: "创建会诊", eventValue: 1 }],
      searchList: [
        {
          label: "协同目的",
          value: 1,
          paramName: "title",
          inputType: "input",
        },
        {
          label: "会诊",
          value: 2,
          paramName: "timeRange",
          inputType: "datetimerange",
          paramstartTime: "startTime",
          paramEndTime: "endTime",
          isTime: true,
          showLabel: true
        },
        {
          label: "发起医生",
          value: 3,
          paramName: "fromDoctorName",
          inputType: "input",
        },
        {
          label: "患者姓名",
          value: 4,
          paramName: "patientName",
          inputType: "input",
        },

        {
          label: "当前状态",
          value: 5,
          paramName: "status",
          inputType: "select",
          default: null,
          optionData: [
            {
              label: "待支付",
              value: "unpay",
            },
            {
              label: "待接诊",
              value: "waiting",
            },
            {
              label: "未开始",
              value: "ready",
            },

            {
              label: "进行中",
              value: "underway",
            },
            {
              label: "已结束",
              value: "ended",
            },
            {
              label: "已退诊",
              value: "rejected",
            },
            {
              label: "已取消",
              value: "canceled",
            },
          ],
        },
      ],
      searchParams: {
        size: 10,
        current: 1,
      },
      tableData: [],
      total: 0,
      synergyStatusObj: {},
      currentVideoIndex: 0,
      lookVideo: false
    };
  },

  watch: {},
  computed: {},
  created() {
    this.getList();
    this.getSynergyStatus();
  },
  mounted() {
    // let { sources } = this.playerOptions;
    // this.currentSourceSrc = sources.length ? sources[0].src : '';
    // this.currentVideoIndex = 0
  },
  methods: {
    // 为关键字的三种状态：匹配成功、未找到关键字、参考值不一致设置颜色
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if(column.property == 'status') {
        // console.log(row)
        if(row.status == 'unpay') {
          return 'unpayClass'; // class名称
        } else if(row.status == 'waiting') {
          return 'waitingClass'; // class名称
        } else if(row.status == 'ready' || row.status == 'ended' || row.status == 'rejected' || row.status == 'canceled') {
          return 'grayClass'; // class名称
        } else if(row.status == 'underway') {
          return 'underwayClass'; // class名称
        }
      }
    },
    moveSelect(e) {
      this.moveBlock(e)
    },
    moveBlock(e) {
      // console.log(e)
      // let parentNode = document.getElementsByClassName("el-dialog");
      let childrenNode = document.getElementsByClassName("ocr-text-wrapper")[0];
      // console.log(childrenNode)
      let computeHeight = Number(getComputedStyle(childrenNode, null)["height"].slice(0, -2));
      // console.log(computeHeight)

      // console.log(e)
      let odiv = e.target; //获取目标元素
      let disX = e.offsetX;
      let disY = e.offsetY;
      document.onmousemove = e => {
        //鼠标事件对象
        var oEvent = e || event;
        if (this.$store.state.isCollapse) {
          var l = oEvent.clientX - disX - 63;
        } else {
          var l = oEvent.clientX - disX - 260;
        }
        var t = oEvent.clientY - disY;

        if (l < 10) {
          l = 0;
        }
        if (t < -20) {
          t = -20;
        }

        childrenNode.style.left = l + "px";
        childrenNode.style.top = t + "px";

        if (this.$store.state.isCollapse) {
          if (document.documentElement.clientWidth - (l + 450) < 10) {
            l = "calc(100% - 450px)";
            childrenNode.style.left = l;
          }
        } else {
          if (document.documentElement.clientWidth - (l + 260 + 450) < 10) {
            l = "calc(100% - 450px)";
            childrenNode.style.left = l;
          }
        }

        if (document.documentElement.clientHeight - (t + computeHeight) < 20) {
          t = document.documentElement.clientHeight - computeHeight - 20;
          childrenNode.style.top = t + "px";
        }

        /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
        childrenNode.style.marginLeft = 0;
        childrenNode.style.marginTop = 0;
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    onPlayerEnded(player) {
      console.log(player,'player配置')
      let { sourcesList } = player.options_;
      let length = sourcesList.length;
      // let currentSourceSrc = ''
      console.log(sourcesList)
      console.log(this.currentSourceSrc)
      sourcesList.forEach((v, i) => {
        if (this.currentSourceSrc === v.src) {
          let index = i === length - 1 ? 0 : ++i
          this.currentVideoIndex = index
          console.log(index)
          this.$set(this.playerOptions, 'sources', [sourcesList[index]])
          this.$refs.videoPlayer.player.load()
        }
      })
      // this.currentSourceSrc = currentSourceSrc;
      this.currentSourceSrc = sourcesList[this.currentVideoIndex].src;
    },
    preVideo() {
      let { sourcesList } = this.playerOptions;
      this.currentVideoIndex = this.currentVideoIndex - 1
      this.$set(this.playerOptions, 'sources', [sourcesList[this.currentVideoIndex]])
      this.$refs.videoPlayer.player.load()
    },
    nextVideo() {
      let { sourcesList } = this.playerOptions;
      this.currentVideoIndex = this.currentVideoIndex + 1
      console.log(this.currentVideoIndex)
      this.$set(this.playerOptions, 'sources', [sourcesList[this.currentVideoIndex]])
      this.$refs.videoPlayer.player.load()
    },

    // 获取录屏数据
    async handleLookVideo(row) {
      let res = await rtcAudioRecord('synergy',row.id);
      console.log(res)
      if (res.code == 0) {
        this.playerOptions.sources = []
        this.playerOptions.sourcesList = []
        // res.data = [
        //   "http://jiayi-agora.oss-cn-hangzhou.aliyuncs.com/agora/recording/1691688491486515201/04e9dbabd44798df66c1d1a88ffe0892_c69d22d0-238b-4d41-b1cd-ba8817f2d36d.m3u8",
        //   'http://jiayi-agora.oss-cn-hangzhou.aliyuncs.com/agora/recording/1691688491486515201/03c3e86c3949d80c3c6496a18171f332_c69d22d0-238b-4d41-b1cd-ba8817f2d36d.m3u8'
        // ]
        if (res.data) {
          res.data.forEach(v => {
            this.playerOptions.sourcesList.push({
              src: v
            })
          })
          this.$nextTick(() => {
            this.playerOptions.sources.push({
              src: res.data[0]
            })
          })
          let { sources } = this.playerOptions;
          console.log(sources)
          this.currentSourceSrc = sources.length ? sources[0].src : '';
          console.log(this.currentSourceSrc)
          this.currentVideoIndex = 0
          console.log(this.playerOptions)
          this.lookVideo = true
        } else {
          this.lookVideo = false
          this.$message.error('该记录无录屏数据')
        }
      }
    },
    handleSizeChange(val) {
      this.searchParams.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.searchParams.current = val
      this.getList()
    },
    // 获取会诊状态枚举
    async getSynergyStatus() {
      let res = await synergyStatus();
      if (res.code == 0) {
        this.synergyStatusObj = res.data;
      }
    },
    handleLookSummary(row) {
      this.selectRecordRow = row;
      this.showSummary = true;
    },
    handleWriteSummary(row) {
      this.selectRecordRow = row;
      this.showSummary = true;
    },
    onEditClick(row) {
      this.$router.push({
        path: "/cooperateWithManage/createConsultation",
        query: { type: "edit", id: row.id },
      });
    },
    onLookClick(row) {
      this.$router.push({
        path: "/cooperateWithManage/createConsultation",
        query: { type: "view", id: row.id },
      });
    },
    goToRoom(row) { 
      this.$router.push({
        name: "IntoTheCase",
        params: {
          keyword: row.patientName,
          patientId: row.patientId,
          tabClickName: 'synergy',
          groupCode: row.chatRoomGroupCode,
          synergyId:row.id
        }
      });
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...this.searchParams, ...obj };
      this.getList();
    },
    async getList() {
      // console.log(this.searchParams)
      let res = await pageSynergyRecord(this.searchParams);
      if (res.code == 0) {
        this.total = res.data.total;
        this.tableData = res.data.records;
      }
    },
    rightFunc(item) {
      this.$router.push({
        path: "/cooperateWithManage/createConsultation",
        query: { type: "add" },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.status-style {
  display: inline-block;
  width: 54px;
  height: 24px;
  border-radius: 2px;
  font-size: 14px;
  color: #333333;
}
.unpayClass span{
  background: #FFDCDB;
}  
.waitingClass span{
  background: #FFECDB;
}  
.grayClass span{
  background: #EEEEEE;
} 
.underwayClass span{
  background: #D3F3E2;
}
/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}
.mr10 {
  margin-right: 10px;
}
/deep/.el-form-item {
  margin-right: 10px;
  // margin-bottom:0;
}
// /deep/.el-tag{
//   margin-left:5px;
// }
.folder-wrapper {
  width: 100%;
  height: 56px;
  // background: #556875;
  background: linear-gradient(135deg, #2A353C 0%, #313E47 100%);
  border-radius: 8px 8px 0px 0px;

  font-size: 12px;
  color: #FFFFFF;
  // text-align: right;
  padding: 0 5px;
  line-height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ocr-text-wrapper {
  position: absolute; /*定位*/
  top: 220px;
  left: 0;
  z-index: 2066;
  margin-left: 4px;
  box-sizing: border-box;
  border-radius: 8px;
  .change-video-btns {
    width: 100%;
    height: 56px;
    background: linear-gradient(135deg, #2A353C 0%, #313E47 100%);
    text-align: center;
    line-height: 56px;
    border-radius: 0px 0px 8px 8px;
    img {
      width: 16px;
      height:16px;
      vertical-align: middle;
    }
    .el-button {
      width: 94px;
      height: 32px;
      background: #556875;
      border-radius: 16px;
      line-height: 32px;
      padding: 0;
      border: none;
      color: #FFFFFF;
    }
  }
}
</style>